export const USER_ACTIONS_TYPES = {
	SET_CURRENT_USER: "user/SET_CURRENT_USER ",
	SET_AUTH_USER: "user/SET_AUTH_USER",
	LOG_OFF_USER: "user/LOG_OFF_USER",
	SET_ADMIN_USER: "user/SET_ADMIN_USER",
	SET_BALANCA_USER: "user/SET_BALANCA_USER"
};
